// import ApiService from '@/store/ApiService.js'

const artistListModule = {
  state: {
    artistList: []
  },
  mutations: {
    artistListModuleSetArtistList (state, playList) {
      state.artistList = playList
    }
  },
  actions: {},
  getters: {
    artistListModuleGetArtistList (state) {
      return state.artistList
    }
  }
}
export default artistListModule



// WEBPACK FOOTER //
// ./src/store/ArtistListModule.js